import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { getBrowserConfig } from './app/app.config';

bootstrapApplication(App, getBrowserConfig())
  // eslint-disable-next-line no-console
  .catch((err) => console.error(err));
